import { AlertBanner } from '@/components/molecules/AlertBanner';

/**
 * Inline error / success banners used inside auth cards. Thin wrappers over the
 * shared `AlertBanner` molecule, kept as named components so the many auth call
 * sites stay stable. Error → assertive `role="alert"`; success → polite
 * `role="status"` (handled by `AlertBanner`).
 */
export function ErrorBanner({ children }: { children: React.ReactNode }) {
  return <AlertBanner variant="error">{children}</AlertBanner>;
}

export function SuccessBanner({ children }: { children: React.ReactNode }) {
  return <AlertBanner variant="success">{children}</AlertBanner>;
}
